(function() {
  'use strict';

  window.FieldStateSelector = function(formObject) {
    this._formObject = formObject;
  };

  FieldStateSelector.prototype.applyFieldState = function($field, field_type, field_state, include_blank, disabled_text, do_not_clear_when_disabled) {
    if ( field_state === null ) { return; } // It doesn't make sense to set field_state for this selector
    if ( !$field ) { return; }
    var field_state_selector = this; // this is redefined in each
    switch(field_type) {
      case 'chosen_select':
        $field.each(function() {
          field_state_selector._selectFieldStateChosen($(this), field_state, include_blank, disabled_text, do_not_clear_when_disabled);
        });
        break;
      case 'text':
        $field.each(function() {
          field_state_selector._selectFieldStateText($(this), field_state);
        });
        break;
      case 'button':
        $field.each(function() {
          field_state_selector._selectFieldStateButton($(this), field_state);
        });
        break;
      case 'splits_button':
        $field.each(function() {
          field_state_selector._selectFieldStateSplitsButton($(this), field_state);
        });
        break;
      case 'select_option':
        $field.each(function() {
          field_state_selector._selectFieldStateSelectOption($(this), field_state);
        });
        break;
      case 'checkbox':
        $field.each(function() {
          field_state_selector._selectFieldStateCheckbox($(this), field_state);
        });
        break;
      default:
        throw('Unexpected field type ' + field_type + ' in _selectFieldState');
    }
  };

  FieldStateSelector.prototype._selectFieldStateChosen = function($field, field_state, include_blank, disabled_text, do_not_clear_when_disabled) {
    switch(field_state) {
      case 0:
        this._selectFieldStateChosenEnabled($field, include_blank, disabled_text);
        return;
      case 2:
        this._selectFieldStateChosenDisabled($field, include_blank, disabled_text, do_not_clear_when_disabled);
        return;
      default:
        throw('Unexpected field_state ' + field_state + ' in _selectFieldStateChosen')
    }
  };

  FieldStateSelector.prototype._selectFieldStateText = function($field, field_state) {
    switch(field_state) {
      case 0:
        this._selectFieldStateTextEnabled($field);
        return;
      case 1:
        this._selectFieldStateTextReadonly($field);
        return;
      case 2:
        this._selectFieldStateTextDisabled($field);
        return;
      default:
        throw('Unexpected field_state ' + field_state + ' in _selectFieldStateText')
    }
  };

  FieldStateSelector.prototype._selectFieldStateButton = function($field, field_state) {
    switch(field_state) {
      case 0:
        this._selectFieldStateButtonEnabled($field);
        return;
      case 2:
        this._selectFieldStateButtonDisabled($field);
        return;
      default:
        throw('Unexpected field_state ' + field_state + ' in _selectFieldStateButton')
    }
  };

  /*
  * The splits button has some extra behaviour associated with it, so gets its own method
  * If it is disabled, we need to ensure that the BT/Inv is not flagged as split, and has no split line items
  */
  FieldStateSelector.prototype._selectFieldStateSplitsButton = function($field, field_state) {
    switch(field_state) {
      case 0:
        this._selectFieldStateButtonEnabled($field);
        return;
      case 2:
        this._selectFieldStateSplitsButtonDisabled($field);
        return;
      default:
        throw('Unexpected field_state ' + field_state + ' in _selectFieldStateSplitsButton')
    }
  };

  FieldStateSelector.prototype._selectFieldStateSelectOption = function($field, field_state) {
    throw('_selectFieldStateSelectOption was called but is not implemented for this formObject')
  };

  FieldStateSelector.prototype._selectFieldStateCheckbox = function($field, field_state) {
    throw('_selectFieldStateCheckbox was called but is not implemented for this formObject')
  };

  function changesMadeToSelect($field, include_blank) {
    var changes_made = _removeBlankSelectOption(include_blank, $field);
    changes_made = _setChosenSelectToEnabled($field) || changes_made;
    return changes_made
  }

  /*
    Remove a blank option from the select

    Return true if we removed one (so we know chosen select needs updating)
  */
  function _removeBlankSelectOption(include_blank, $field) {
    if ( !include_blank ) {
      $field.find('option[value=""]').remove();
      return true
    }
  }

  /*
    Set the field to disabled
    Return true if this was a change (so we know chosen select needs updating)
  */
  function _setChosenSelectToEnabled($field) {
    if ( $field.prop("disabled") ) {
      $field.prop("disabled", false);
      return true
    }
  }

  function _setSpanTextIfNoValue($field) {
    if ( !$field.val() || !$field.val().length ) {
      $field.closest('.select').find('span').html('Select an option')
    }
  }

  /**
  * On BT imports, if we change back to MO/MI from CR/SP,
  * we want to reinstate the default values we've cleared
  * @param $field
  */
  // PANDLE: Overridden to prevent it clearing values calculated by stimulus controller
  FieldStateSelector.prototype._resetToDefaultValue = function($field) {
    if ($field.data().bankImportedTransactionsLineItemRowTarget == "taxAmount") return; //FARMPLAN
    if ($field.data().lineItemRowTarget == "taxAmount") return; //FARMPLAN
    // FARMPLAN: Don't reset net/tax amounts when changing transaction types - preserve the values
    // calculated with the current tax code
    if (this._formObject && this._formObject.getFlagValue('changingTransactionType')) {
      if ($field.hasClass('net_amount_field') || $field.hasClass('tax_amount_field')) return;
    }
    var default_val = $field.prop("defaultValue");
    if (default_val.length > 0) {
      $field.val(default_val);
    } else {
      this._clearValueUnlessOnPageload($field);
    }
  }

  FieldStateSelector.prototype._clearValueUnlessOnPageload = function($field) {
    if ( this._formObject.getFlagValue('rowHasAlreadyBeenInitialized') ) {
      $field.val(null)
    }
  }

  FieldStateSelector.prototype._selectFieldStateChosenEnabled = function($field, include_blank, disabled_text) {
    if ( changesMadeToSelect($field, include_blank) ) {
      // Don't trigger chosen:updated if we haven't changed anything as this can have odd effects...
      $field.trigger('chosen:updated');
    }
    _setSpanTextIfNoValue($field);
  };

  FieldStateSelector.prototype._selectFieldStateChosenDisabled = function($field, include_blank, disabled_text, do_not_clear_when_disabled) {
    if ( !do_not_clear_when_disabled ) { $field.prepend('<option value=""/>').val('') }
    $field.prop("disabled", true);
    $field.trigger('chosen:updated');
    if ( disabled_text ) { $field.closest('.select').find('span').html(disabled_text) }
  };

  FieldStateSelector.prototype._selectFieldStateTextEnabled = function($field) {
    if ( $field.attr('readonly') ) {
      $field.removeAttr('readonly');
      this._resetToDefaultValue($field);
    }
    $field.prop('disabled', false);
  };

  FieldStateSelector.prototype._selectFieldStateTextReadonly = function($field) {
    $field.attr('readonly', true);
  };

  FieldStateSelector.prototype._selectFieldStateTextDisabled = function($field) {
    $field.val('');
    $field.prop('disabled', true);
  };

  FieldStateSelector.prototype._selectFieldStateButtonEnabled = function($field) {
    $field.removeClass('disabled');
  };

  FieldStateSelector.prototype._selectFieldStateButtonDisabled = function($field) {
    $field.addClass('disabled');
  };

  FieldStateSelector.prototype._selectFieldStateSplitsButtonDisabled = function($field) {
    $field.addClass('disabled');
    if ( this._formObject.getFlagValue('isSplit')) {
      this._formObject.getSplitField().val(false).change();
    }
  }
})();
